import { useState, useEffect } from 'react';
import api from '@/shared/api';
import config from '@/config';
const useFiscalRealEstates = (relationId) => {
    const [realEstates, setRealEstates] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        api.base
            .get(`${config.appUrls.api}/api/Fiscal/realEstates/${relationId}`)
            .then(({ data }) => {
            setRealEstates(data || []);
            setLoading(false);
        })
            .catch(() => {
            setLoading(false);
        });
    }, [relationId]);
    return { realEstates, loading };
};
export default useFiscalRealEstates;
